import React from "react";
import Loader from "./Loader";

/**
 * Reusable submit button component with loading state
 * @param {string} text - Button text
 * @param {boolean} isLoading - Loading state
 * @param {boolean} disabled - Disabled state
 * @param {string} className - Additional CSS classes
 * @param {string} id - Button ID
 * @param {Object} rest - Other button props
 */
export const SubmitButton = ({
  text,
  isLoading = false,
  disabled = false,
  className = "button sub_primary mt-2",
  id,
  ...rest
}) => {
  return (
    <button
      type="submit"
      className={className}
      id={id}
      disabled={isLoading || disabled}
      {...rest}
    >
      <span>
        <span className="text-base">{text}</span>
        {isLoading ? (
          <Loader className="loader_cls" />
        ) : (
          <img
            src="/image/buttonArrow.27e5232.svg"
            alt="icon"
            className="absolute right-0 top-0 mt-3 mr-8"
          />
        )}
      </span>
    </button>
  );
};

